import { render, staticRenderFns } from "./ReviewInfo.vue?vue&type=template&id=171dda00&"
import script from "./ReviewInfo.vue?vue&type=script&lang=ts&"
export * from "./ReviewInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports